"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stagEnv = function () { return ({
    NAME: 'stag',
    ASSET_ROOT: '/assets/',
    BOOKSTORE_ROUTER_BASE_NAME: '/',
    BUILDER_HOST: 'https://stag-builder.rowan.nyc/',
    BUILDER_UI_HOST: 'https://dhkng1ty7ycb8.cloudfront.net/',
    PLATFORM: 'web',
    NATIVE_APPLICATION: false,
    READER_BASE_URL: 'https://s3.amazonaws.com/rowan-builder-stag/reader-v-2',
    READER_URL: 'https://stag-reader.rowan.nyc/',
    RUCKSACK_CALLBACK: 'https://stag-reader.rowan.nyc/',
    RUCKSACK_CLIENT_ID: 'b9ed54f16b9fd7be9bd3521f074f5e607c19beb9a429beadc7cb5bf5e1a3e7df',
    RUCKSACK_HOST: 'https://stag-rucksack.rowan.nyc',
    RUCKSACK_URL: 'https://stag-rucksack.rowan.nyc/',
    RUCKSACK_SECRET: '907362d1f6977e9735de796557f86534cd64f3e58abab89d2f306721d8bc28a3',
    BOOKSHELF_URL: 'https://stag-app.rowan.nyc',
    BOOKSHELF_AUTH_URL: 'https://stag-app.rowan.nyc/loadAuthToken.html',
    FEATURE_FLAG_URL: '/feature-flags.json',
    API_GATEWAY_URL: 'https://stag-gateway.rowan.nyc/',
    SECURE_COOKIES: true,
    COOKIE_DOMAIN: 'rowan.nyc'
}); };
exports.default = stagEnv;
